<!--
    Пример использования в родительском компоненте (удалить комментарии при использовании)

    <ff-input-lang
        label="Имя"                                 необязательное, отображаемое наименование поля
        hint="Укажите имя"                          необязательное, отображаемая текст/подсказка под полем
        fieldId="name"                              необязательное, id поля, требуется для связи label с полем, по умолчанию генеритсяуникальный id
        fieldName="name"                            обязательное, наименование поля, используется в ответе
        fieldType="text"                            необязательное, тип поля, по умолчанию text
        [clearField]="clearField"                   необязательное, true / false, выводиткнопку для очистки поля, по умолчанию значение false
        [validator]="validator.name"                необязательное, стандартный массив с валидаторами
        [errorMessages]="errorMessages.name"        необязательное, массив с перечнем сообщений для валидатора (пример ниже)
        [required]="required"                       необязательное, true / false - определяет отображать ли красную звездочку у названия поля, если валидаторы не переданы то так же по дефолту включаетвалидатор required, если валидатор передан то его требуется описать в validator и в errorMessages 
        (ChangeValue)="eventFn($event)"             обязательное, событие ChangeValue возвращаем объект с данными на всех доступных языках, и статус валидности (пример ниже)
        [placeholder]="placeHolder"                 необязательное, текст внутри поля
    ></ff-input-lang>


    Пример массива с перечнем сообщений для валидатора
    [
        {
          type: 'required', 
          message: 'MESSAGES.REQUIRED_FIELD',
          options: null
        }
    ]

    Пример объекта с данными возвращаемого событием ChangeValue
    {
        name: {
            en: null,
            kk: null,
            ru: "Василий"
        },
        valid: false
    }
-->


<form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

    <div class="form-group">

        <label *ngIf="label" for="{{fieldId}}" class="label">{{ label }} 
            <svg-icon *ngIf="required" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
        </label>

        <div class="ff-group">

            <ng-select class="custom-lang" placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}" bindLabel="value"
                bindValue="code2" formControlName="currentLang" [items]="languages" [dropdownPosition]="'bottom'"
                [clearable]="false" appendTo="body">
            </ng-select>

            <input class="form-control lang" [placeholder]="placeHolder" [ngClass]="{'clear-field': form.get('field').value}"
                formControlName="field" [name]="fieldName" [type]="fieldType" [id]="fieldId" [readonly]="readonly">

            <div *ngIf="clearField && form.get('field').value" class="input-group-append">
                <button class="btn btn-none" type="button" (click)="clearingField()" placement="left"
                tooltipClass="clue-name" ngbTooltip="{{ 'CLEAN_CURRENT_LANGUAGE' | translate }}" tooltipClass="clue-name" [closeDelay]="300">
                    <svg-icon src="/assets/images/icons/close-circle.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                </button>
            </div>

        </div>

        <small *ngIf="hint" class="form-text text-muted">{{ hint }}</small>

        <!-- <div *ngIf="errorMessages">
            <div *ngFor="let item of errorMessages">
                <div class="text-error" *ngIf="validation('field', item.type)">
                    {{ item.message | translate: item.options }}
                </div>
            </div>
        </div> -->

        <div formArrayName="list">
            <div *ngFor="let elem of form.get('list')['controls']; let i = index;">
                <div [formGroupName]="i">

                    <div *ngIf="errorMessagesForLang">
                        <div *ngFor="let item of errorMessagesForLang">
                            <div class="text-error" *ngIf="validation(['list', i, 'value'], item.type)">
                                {{ item.message | translate: { fieldName: getLangComparison(languages[i].value) } }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</form>